import { render, staticRenderFns } from "./DeputyCeoMessage.vue?vue&type=template&id=6a0b24ec&scoped=true&"
import script from "./DeputyCeoMessage.vue?vue&type=script&lang=js&"
export * from "./DeputyCeoMessage.vue?vue&type=script&lang=js&"
import style0 from "./DeputyCeoMessage.vue?vue&type=style&index=0&id=6a0b24ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b24ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
